export default __webpack_public_path__ + "static/media/Holcim.e9ff6b80.svg";